import { SetStateAction } from 'react';
import { FiltersData } from '@/types/offerWall';
import Select from '../Select/Select';
import RangeInput from '../RangeInput/RangeInput';
import Checkbox from '../Checkbox/Checkbox';
import NextButton from '../../Button/NextButton';
import useModal from '@/hooks/useModal';
import styles from './OfferFiltersModal.module.scss';

interface Props {
  handleClearFilters?: () => void;
  minAmount?: number;
  maxAmount?: number;
  minApr?: number;
  maxApr?: number;
  filtersData?: FiltersData;
  setFiltersData?: React.Dispatch<SetStateAction<FiltersData>>;
  lenders?: string[];
  handleSort?: (value: 'rate' | 'amount' | 'term' | null) => void;
}

const OfferFiltersModal = ({
  handleClearFilters,
  minAmount,
  maxAmount,
  minApr,
  maxApr,
  filtersData,
  setFiltersData,
  lenders,
  handleSort,
}: Props) => {
  const { closeModal } = useModal();

  if (!filtersData || !setFiltersData) return null;

  return (
    <article className={styles.filtersWrapper}>
      <div className={styles.head}>
        <span className={styles.title}>Filters & sort</span>
        <button
          onClick={handleClearFilters}
          className={styles.clearAll}
          type="button"
        >
          Clear All
        </button>
      </div>
      {handleSort && (
        <Select
          filtersData={filtersData}
          handleSort={handleSort}
          placeholder="Sort by options"
        />
      )}
      <RangeInput
        filtersData={filtersData}
        setFiltersData={setFiltersData}
        type="amount"
        label="Loan Amount"
        min={Math.floor(minAmount || 0)}
        max={Math.floor(maxAmount || 0)}
        styles={styles}
        format="dollars"
      />
      <RangeInput
        filtersData={filtersData}
        setFiltersData={setFiltersData}
        type="rate"
        label="Max APR"
        min={Math.floor(minApr || 0)}
        max={Math.floor(maxApr || 0)}
        styles={styles}
        format="percent"
      />
      <div className={styles.block}>
        <div className={styles.label}>
          <span style={{ opacity: 0.6 }}>Lender</span>
        </div>
        <div className={styles.checkboxWrapper}>
          {lenders?.map((lender) => (
            <Checkbox
              key={lender}
              label={lender}
              currentLenders={filtersData.lenders}
              setFiltersData={setFiltersData}
            />
          ))}
        </div>
      </div>
      <NextButton
        onClick={closeModal}
        type="button"
        buttonType="button"
        variation="primary"
        text="Apply changes"
        styles={styles.button}
      />
    </article>
  );
};

export default OfferFiltersModal;
